<script setup>

import {ref} from "vue";
import StyleSetting from "./styleSetting.vue";

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
    modelValue: {
        type: Object,
        required: false,
        default: () => {
            return {
                version: 1,
                settings: {
                    paddingPreset: {
                        top: 'none',
                        right: 'none',
                        bottom: 'none',
                        left: 'none',
                    },
                }
            }
        }
    }
})

const blockLayoutSettings = ref(props.modelValue)

const updateStyleSetting = (property, value) => {
    blockLayoutSettings.value.settings[property] = value
    emit('update:modelValue', props.modelValue)
}

</script>
<template>
    <div>
        <div>
            <StyleSetting
                :styletype="'presetBasedPadding'"
                :title="_mft('pagebuilder:styleEditor.padding')"
                :stylevalue="blockLayoutSettings.settings.paddingPreset"
                :presets="[
                    {label: _mft('pagebuilderBlock:general.input.size.none'), value: 'none'},
                    {label: _mft('pagebuilderBlock:general.input.size.tiny'), value: 'tiny'},
                    {label: _mft('pagebuilderBlock:general.input.size.small'), value: 'small'},
                    {label: _mft('pagebuilderBlock:general.input.size.medium'), value: 'medium'},
                    {label: _mft('pagebuilderBlock:general.input.size.large'), value: 'large'},
                    {label: _mft('pagebuilderBlock:general.input.size.huge'), value: 'huge'},
                ]"
                @update:model-value="(e) => updateStyleSetting('paddingPreset', e)"
            />
        </div>
    </div>
</template>
